(() => {
  if (window.bmFlashInstalled) return;
  window.bmFlashInstalled = true;
  const timers = new Map();
  function init(root) {
    if (timers.has(root)) clearInterval(timers.get(root));
    timers.delete(root);
    root.hidden = false;
    root.removeAttribute('data-finished');
    const status = root.querySelector('[data-status]');
    const digits = root.querySelector('[data-digits]');
    const raw = (root.dataset.end || '').trim();
    const validFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/.test(raw);
    const end = validFormat ? Date.parse(raw) : NaN;
    status.hidden = true;
    digits.hidden = false;
    if (!Number.isFinite(end)) {
      digits.hidden = true;
      if (window.Shopify && window.Shopify.designMode) {
        status.textContent = 'Configura la fecha de término con zona horaria, por ejemplo: 2026-10-07T23:00:00-03:00.';
        status.hidden = false;
      }
      return;
    }
    function tick() {
      const remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
      root.querySelector('[data-hours]').textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
      root.querySelector('[data-minutes]').textContent = String(Math.floor(remaining % 3600 / 60)).padStart(2, '0');
      root.querySelector('[data-seconds]').textContent = String(remaining % 60).padStart(2, '0');
      if (remaining === 0) {
        root.setAttribute('data-finished', '');
        status.textContent = root.dataset.expired || 'Oferta finalizada';
        status.hidden = false;
        if (root.dataset.hiddenExpired === 'true' && !(window.Shopify && window.Shopify.designMode)) root.hidden = true;
        if (timers.has(root)) clearInterval(timers.get(root));
        timers.delete(root);
        return false;
      }
      return true;
    }
    if (tick()) timers.set(root, setInterval(tick, 1000));
  }
  function scan(scope) {
    if (scope.matches && scope.matches('[data-bm-flash]')) init(scope);
    scope.querySelectorAll('[data-bm-flash]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, timer] of timers) {
      if (event.target.contains(root)) { clearInterval(timer); timers.delete(root); }
    }
  });
})();
